<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
  <div class="top">
    <a routerLink="/home/vacations/management">
      <h3>Vacaciones chóferes / Ejercicio {{ year }}/</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>{{ year }}</h2>
      </div>
    </a>
  </div>
</div>

<div class="content">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    
    <mat-tab label="CHÓFERES">
      <app-petitions [onlyPetitions]="false" [exerciseId]="id" 
        [reloadFlag]="reloadFlag" (exportLoading)="onExportLoading($event)">
      </app-petitions>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-badge-label">
          PETICIONES PENDIENTES
        </span>
      </ng-template>
      <app-petitions [onlyPetitions]="true" [exerciseId]="id"
        [reloadFlag]="reloadFlag"></app-petitions>

    </mat-tab>

  </mat-tab-group>
</div>